import React from 'react';
import SocialButton from '../SocialButton';

const FACEBOOK = 'facebook';
const TWITTER = 'twitter';
const PINTEREST = 'pinterest';

const formatSocialUrl = url => name => image => (site) => {
  switch (site) {
    case FACEBOOK:
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&p[title]=${name}&p[images][0]=${encodeURIComponent(image)}`;
    case TWITTER:
      return `https://twitter.com/share?url=${encodeURIComponent(url)}&text=${name}`;
    case PINTEREST:
      return `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(image)}&description=${name}`;
    default: {
      if (process.env.NODE_ENV !== 'production') {
        throw new Error('Invalid Social website provided to SocialButton');
      }
      return '';
    }
  }
};

type SocialButtonListProps = {
  productUrl: ?string,
  productName: ?string,
  productImage: ?string,
};

const SocialButtonList = ({
  productUrl,
  productName,
  productImage,
}: SocialButtonListProps) => {
  const socialLinkCreator = formatSocialUrl(productUrl)(productName)(productImage);
  const socialSites = [FACEBOOK, TWITTER, PINTEREST];
  return (
    <div className="pdp-social-icons-container">
      <h2 className="pdp-social-icons-title">
        Share
      </h2>

      <ul className="pdp-social-icons">
        {socialSites.map(site => <SocialButton key={site} site={site} url={socialLinkCreator(site)} />)}
      </ul>
    </div>
  );
}

export default SocialButtonList;


// WEBPACK FOOTER //
// ./src/components/SocialButtonList/index.js